import {combineReducers} from "redux";
import App from "../components/app/appReducer";

const rootReducer = combineReducers({
        App,
});

export default rootReducer;
